<!-- eslint-disable max-len -->
<template>
  <v-row justify="end" class="mr-12">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          color="#004984"
          v-bind="props"
          class="button-config"
          style="color: white"
        >
          Cadastrar Charter
          <v-icon right style="margin-left: 5px">mdi-plus</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Cadastrar Charter</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="objetivo"
                    required
                    label="Objetivo*"
                    placeholder="Finalidade do charter"
                    rows="2"
                    :rules="objetivoRules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="csuSelecionado"
                    required
                    label="Caso de Uso*"
                    :items="this.csuOpcoes.map((csu) => csu.nome)"
                    :rules="csuSelecionadoRules"
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="preCondicao"
                    :rows="3"
                    label="Pré-Condição*"
                    placeholder="Condições que devem ser satisfeitas antes dos testes"
                    required
                    :rules="preCondicaoRules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="observacao"
                    :rows="3"
                    label="Observação*"
                    placeholder="Informações adicionais sobre o charter"
                    required
                    :rules="observacaoRules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-select
                    v-model="this.storypoint"
                    label="Storypoint da Tarefa*"
                    :items="storypoints"
                    :rules="storypointRules"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-select
                    v-model="this.repositorio"
                    label="Repositorio da Tarefa*"
                    :items="repositoriosNome"
                    required
                    :rules="repositorioRules"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-select
                    v-model="this.prioridade"
                    label="Prioridade da Tarefa*"
                    :items="prioridades"
                    :rules="prioridadeRules"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitCharter()">
            Salvar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module CreateCharter
 * @desc Modal com formulário para a criação de um charter.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal está visível.
 * @vue-data {string} [csuSelecionado=''] - Nome do caso de uso selecionado.
 * @vue-data {Array.<Object>} [csuOpcoes=[]] - Array com os casos de uso do
 * projeto.
 * @vue-data {string} [prioridade=''] - A prioridade selecionada.
 * @vue-data {Array.<string>} prioridades - Array com as prioridades
 * possíveis.
 * @vue-data {string} [repositorio=''] - O repositório selecionado.
 * @vue-data {Array.<Object>} repositorios - Array com os repositórios
 * do projeto.
 * @vue-data {Array.<string>} repositoriosNome - Array com os nomes dos
 * repositórios do projeto.
 * @vue-data {string} [storypoint=''] - O storypoint selecionado.
 * @vue-data {Array.<string>} storypoints - Array com os storypoints
 * possíveis.
 * @vue-data {string} [objetivo=''] - Objetivo do charter.
 * @vue-data {string} [preCondicao=''] - Pré-condição do charter.
 * @vue-data {string} [observacao=''] - Observação para o charter.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se o charter ainda
 * está sendo criado.
 * @vue-data {string} [idProject=''] - O id do projeto.
 */
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  emits: ['charterCriado'],
  data: () => ({
    dialog: false,
    csuSelecionado: '',
    csuOpcoes: [],
    prioridade: '',
    prioridades: ['URGENTE', 'ALTA', 'MEDIA', 'BAIXA'],
    repositorio: '',
    repositorios: [],
    repositoriosNome: [],
    idRepositorio: null,
    storypoint: '',
    storypoints: ['0', '0.5', '1', '2', '3', '5', '8', '13', '20', '40'],
    objetivo: '',
    preCondicao: '',
    observacao: '',
    isLoading: false,
    idProject: '',
    objetivoRules: [
      (v) => !!v || 'Objetivo é obrigatório',
      (v) =>
        (v && v.length <= 200) || 'Objetivo deve ter no máximo 200 caracteres',
    ],
    csuSelecionadoRules: [(v) => !!v || 'Caso de uso é obrigatório'],
    prioridadeRules: [(v) => !!v || 'Prioridade é obrigatória'],
    repositorioRules: [(v) => !!v || 'Repositório é obrigatório'],
    storypointRules: [(v) => !!v || 'Storypoint é obrigatório'],
    preCondicaoRules: [
      (v) => !!v || 'Pré-condição é obrigatória',
      (v) =>
        (v && v.length <= 400) ||
        'Pré-condição deve ter no máximo 400 caracteres',
    ],
    observacaoRules: [
      (v) => !!v || 'Observação é obrigatória',
      (v) =>
        (v && v.length <= 500) ||
        'Observação deve ter no máximo 500 caracteres',
    ],
  }),
  computed: {
    myUserId() {
      return localStorage.getItem('idUsuario');
    },
  },
  created() {
    this.idProject = this.$route.params.idProjeto;
    // console.log(idProject);
    this.fetchUseCasesByProject(this.idProject);
    this.fetchRepositorios();
  },

  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza requisição HTTP para buscar os repositórios do projeto.
     */
    async fetchRepositorios() {
      const response = await axios.get(
        `${apiUrl}/projetos/${this.idProject}/repositorios/`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        },
      );
      this.repositorios = response.data;
      this.repositoriosNome = this.repositorios.map(
        (repositorio) => repositorio.tb_repositorio.nome,
      );
    },

    // Obtém o id do repositório selecionado.
    getIdRepositorio() {
      const repositorio = this.repositorios.find(
        (repositorio) => repositorio.tb_repositorio.nome == this.repositorio,
      );
      this.idRepositorio = repositorio.tb_repositorio.id_repositorio;
    },

    /**
     * Realiza uma requisição HTTP para obter os casos de uso de um projeto.
     *
     * @param {String} idProject O id do projeto.
     */
    fetchUseCasesByProject(idProject) {
      axios
        .get(apiUrl + '/api/v1/productBacklog/projeto/' + idProject, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          // console.log(res.data.useCases);
          this.csuOpcoes = res.data.useCases;
          // this.useCases = res.data.useCases;
        })
        .catch((error) => console.log(error));
    },

    /**
     * Realiza uma requisição HTTP para criar um novo charter.
     */
    async submitCharter() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        this.isLoading = true;

        const csu = this.csuOpcoes.filter(
          (csu) => csu.nome === this.csuSelecionado,
        )[0];

        if (this.repositorio) {
          this.getIdRepositorio();
        }

        try {
          // Obtém a quantidade de charters para o caso de uso em questão
          const resultCharters = await axios.get(
            `${apiUrl}/api/v1/charters/projeto/${this.idProject}`,
            {
              headers: { Authorization: `Bearer ${store.state.token}` },
            },
          );
          console.log(resultCharters);
          const dataTarefa = {
            titulo: '' + `${this.objetivo}`,
            descricao: `
            Pre-condição: ${this.preCondicao}
            ${this.observacao}`,
            storypoint: this.storypoint,
            prioridade: this.prioridade,
            tipo_tarefa: 'TESTE_INDEPENDENTE', // eslint-disable-line
            id_projeto: parseInt(this.idProject), // eslint-disable-line
            id_repo: parseInt(this.idRepositorio), // eslint-disable-line
          };
          // const dataTarefa = {
          //   titulo:
          //     '' +
          //     `Teste Independente ${
          //       resultCharters.data.charters.length + 1
          //     } - ${csu.identificador}`,
          //   descricao: `Esta tarefa tem como objetivo: ${this.objetivo}`,
          //   storypoint: this.storypoint,
          //   prioridade: this.prioridade,
          //   tipo_tarefa: 'TESTE_INDEPENDENTE', // eslint-disable-line
          //   id_projeto: parseInt(this.idProject), // eslint-disable-line
          //   id_repo: parseInt(this.idRepositorio), // eslint-disable-line
          // };

          const resultTarefa = await axios.post(
            `${apiUrl}/tarefas/criar`,
            dataTarefa,
            {
              headers: { Authorization: `Bearer ${store.state.token}` },
            },
          );

          // Se a tarefa foi cadastrada com sucesso.
          if (resultTarefa) {
            const data = {
              identificacao: '',
              // eslint-disable-next-line camelcase
              id_tarefa: parseInt(resultTarefa.data.resposta.id_tarefa),
              // eslint-disable-next-line camelcase
              id_caso_de_uso: parseInt(csu.id_caso_de_uso),
              // eslint-disable-next-line camelcase
              pre_condicao: this.preCondicao,
              // eslint-disable-next-line camelcase
              id_usuario: parseInt(this.myUserId),
              objetivo: this.objetivo,
              observacao: this.observacao,
              // eslint-disable-next-line camelcase
              status_charter: 'PLANEJADO',
              // eslint-disable-next-line camelcase
              id_projeto: parseInt(this.idProject),
            };

            const result = await axios.post(`${apiUrl}/api/v1/charters`, data, {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            });

            this.$toast.success(result.data.msg);
            this.$emit('charterCriado', this.idProject);
            this.$router.push(`/projects/${this.idProject}/Charters`);
          }
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.dialog = false;
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
<style scoped>
.button-config {
  background-color: #004984;
  text-transform: capitalize;
}
</style>
